import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {BUTTON_PRIMARY, SUCCESS} from '../assets/constants/Constants';
import ButtonComponent from '../components/ButtonComponent';
import { useLocation } from "react-router-dom";
import DuroltLogo from "../assets/images/durolt_logo_new.svg";
import { getAssignedLockerList } from '../api/api';
import { getSecureItemFromSpecificStorage } from '../lib/BrowserStorageAccessMiddleware';
import {LOCAL_STORAGE, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS } from '../assets/constants/BrowserStorageKeys';
import CircularProgressLoader from '../components/CircularProgressLoader';
import { buildInvoiceList } from '../lib/Utils';

const InvoicePage = () => {
	const { t } = useTranslation();
	const [showLoader, setShowLoader] = useState(false);
	const [loadingMessage, setLoadingMessage] = useState(t('Loading'));
	const location = useLocation();
	const settings = getSecureItemFromSpecificStorage(LOCAL_STORAGE,LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS)
	const {lockerItem } = location.state || {};
	const [invoices, setInvoices] = useState([]);
	
	
	const getAssignedLockers = async (assignmentId) => {
		try {
			const response = await getAssignedLockerList(assignmentId);
			if (response?.status !== SUCCESS) {
				setInvoices([]);
				return;
			}
			const invoiceList = buildInvoiceList(response.data);
			setInvoices(invoiceList);
		} catch (error) {
			console.error("Error fetching assigned lockers:", error);
			setInvoices([]);
		} finally {
			setShowLoader(false);
			setLoadingMessage("");
		}
	};


	useEffect(() => {
		const init = async () => {
			setShowLoader(true);
			setLoadingMessage(t('loading'));
			if (lockerItem) {
			const invoiceList = buildInvoiceList([lockerItem]);
			setInvoices(invoiceList);
			setShowLoader(false);
			setLoadingMessage("");
			return;
			}
			if (settings?.id) {
				await getAssignedLockers(settings.id);
				return;
			}
			setInvoices([]);
			setShowLoader(false);
			setLoadingMessage("");
		};
		init();
}, [lockerItem, settings?.id]);

	const handlePrint = () => {
		window.print();
	};

	const isSingleInvoice = invoices.length === 1;

	return (
		<div className="invoice-page">
			{invoices.length >= 1 ? (
				<>
				{invoices.map((inv, idx) => (
					<div className="invoice-card" key={inv.invoice_no || idx}>
					<div className="invoice-header">
						<div className="image-container">
						<img
							src={DuroltLogo}
							alt={t("durolt_logo")}
							className="header-image"
						/>
						</div>
						<div className="text-container">
							<p className="company-title">{t("durolt")}</p>
							<p className="company-address">{t("invoice_company_city")}</p>
						</div>
					</div>

					<hr />

					<div className="invoice-details">
						<p><strong>{t("invoice_date_label")}</strong> {inv.date}</p>
						<p><strong>{t("invoice_time_label")}</strong> {inv.time}</p>
						<p><strong>{t("invoice_number_label")}</strong> {inv.invoice_no}</p>
						<p><strong>{t("invoice_payment_id_label")}</strong> {inv.payment_id}</p>
						<p><strong>{t("invoice_locker_bank_label")}</strong> {inv.locker_bank}</p>
						<p><strong>{t("invoice_location_label")}</strong> {inv.location}</p>
						<p><strong>{t("invoice_payment_method_label")}</strong> {inv.payment_method}</p>
						<p><strong>{t("invoice_customer_id_label")}</strong> {inv.customer_id}</p>
					</div>

					<div className="amount">
						{inv.currency} <span>{inv.amount}</span>
					</div>

					<div className="rental-details">
						<p className="signature">{t("invoice_signature_not_required")}</p>
						<p className="agreement">
						{t("invoice_agreement_text")}
						</p>
					</div>

					<hr />

					<div className="invoice-footer">
						<div className="copy">{t("invoice_customer_copy")}</div>
						<div className="brand-box">{t("durolt")}</div>
					</div>

					{isSingleInvoice && (
						<ButtonComponent
						buttonId="print-invoice-button"
						handleClick={handlePrint}
						title={"print_Invoice"}
						type={BUTTON_PRIMARY}
						/>
					)}
					</div>
				))}

				{!isSingleInvoice && invoices.length > 1 && (
					<div className="print-btn-wrapper global-print-btn">
					<ButtonComponent
						buttonId="print-all-invoices"
						handleClick={handlePrint}
						title={"print_All_Invoices"}
						type={BUTTON_PRIMARY}
					/>
					</div>
				)}
				</>
			) : (
				<p className="no-invoice-text">
				{t("noInvoicesAvailable")}
				</p>
			)}

			{showLoader && <CircularProgressLoader message={loadingMessage} />}
	</div>
	);
};

export default InvoicePage;
